module.exports = __webpack_public_path__ + "img/Frame_23.6c1fa57e.png";